import { useQuery } from "@tanstack/react-query";
import { Combobox } from "./ui/combobox";
import { listBusinessUnits } from "@/lib/business-unit";
import { useState } from "react";

type Props = {
  value?: string;
  name?: string;
  id?: string;
  className?: string;
};

export const BusinessUnitPicker = ({
  value = "",
  name,
  id,
  className,
}: Props) => {
  const [formValue, setFormValue] = useState(value);
  const { isPending, isSuccess, data } = useQuery({
    queryKey: ["businessUnit"],
    queryFn: listBusinessUnits,
  });

  const onChange = (value: string) => setFormValue(value);
  const businessUnits = data ? data : [];

  return (
    <div className={className}>
      <input type="hidden" id={id} name={name} value={formValue} />
      <Combobox
        disabled={!isSuccess}
        options={businessUnits.map((bu) => ({
          value: bu.id.toString(),
          label: bu.name,
        }))}
        value={formValue}
        onChange={onChange}
        placeholder={
          isPending ? "Loading business units..." : "Select a business unit"
        }
        searchPlaceholder="Search business units..."
        emptyMessage={
          isPending
            ? "Loading..."
            : businessUnits.length === 0
              ? "No business units found."
              : "No matching business units."
        }
      />
    </div>
  );
};
